import { createReducer, on } from "@ngrx/store";
import { applicationsFormGroup, applicationsSearch, applicationsSearchType, applicationsTabChanged } from "../actions/tab-applications.actions";
//reducer is used to store values in global store -> StoreModule.forRoot({}, {}) in src/app/app.module.ts
//reducer starting state
const initialState = null;
export const applicationTabReducer = createReducer(initialState, on(applicationsSearch, (state, action) => action.value));
export const searchTypeReducer = createReducer(initialState, on(applicationsSearchType, (state, action) => action.value));
export const formGroupReducer = createReducer(initialState, on(applicationsFormGroup, (state, action) => action.value));
export const tabChangedReducer = createReducer(initialState, on(applicationsTabChanged, (state, action) => action.value));
